module.exports = __webpack_public_path__ + "img/ups-account.4f8c57df.svg";